import { render, staticRenderFns } from "./ArticuloFamilia.vue?vue&type=template&id=a3f723a8&scoped=true&"
import script from "./ArticuloFamilia.vue?vue&type=script&lang=js&"
export * from "./ArticuloFamilia.vue?vue&type=script&lang=js&"
import style0 from "./ArticuloFamilia.vue?vue&type=style&index=0&id=a3f723a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f723a8",
  null
  
)

export default component.exports